<div class="container-fluid px-3 py-4 bg-white">
  <div class="bg-light p-2">
    <h3 class="mb-0 text-primary">Find a Petitioner</h3>
  </div>

  <form [formGroup]="petitionerForm" class="mt-3">
  <div class="row">
    <div class="col-3">
      <label class="d-block">Employee Name</label>
      <p-autoComplete class="w-100"
      formControlName="employeeName" [virtualScroll]="true" field="employerName" [suggestions]="employeeResults" [itemSize]="50" (completeMethod)="filterEmployee($event)">
      </p-autoComplete>
    </div>
    <div class="col-3">
      <label class="d-block">NAICS Code</label>
      <p-autoComplete class="w-100" formControlName="naicsCode" field="naicsTitle" [virtualScroll]="true" [suggestions]="naicsResults" [itemSize]="50" (completeMethod)="filterNaics($event)">
      </p-autoComplete>
      <div *ngIf="petitionerForm.get('naicsCode').touched && naicsResults.length == 0">NAICS Codes for given search value is not found.</div>
      
    </div>
    <div class="col-3">
      <label class="d-block">State</label>
      <p-dropdown inputId="state" [options]="stateList" formControlName="state" class="w-100"
          optionLabel="stateProvinceName" [filter]="true" filterBy="stateProvinceName"
          name="state" placeholder="Select a State"> </p-dropdown>
    </div>
    <div class="col-3">
      <label class="d-block"></label>
      <button 
          type="button" pButton label="Search" class="text-uppercase mt-4"
          (click)="searchPetitioner();"></button> 
    </div>
  </div>
</form>
  </div>

  <div *ngIf="totalElementCount > 0 && !employerDialogDisplay" class="container-fluid px-3 py-4 bg-white">
    <p-table  
    [value]="findEmployerResult">
    <ng-template pTemplate="header">
      <tr>
          <th class="col-4">Employer</th>
          <th class="col-4">NAICS Code</th>
          <th class="col-4">State</th>
      </tr>
  </ng-template>
    <ng-template pTemplate="body" let-item>
       
      <tr>
        <td>
            <a class="pe-pointer">
              <span (click)="markFav(item)"  title="Unmark Favorite" class="pi pi-star" *ngIf="item.isFavorite == true">  
              </span>
              <span (click)="markFav(item)" title="Mark Favorite" class="pi pi-star-o" *ngIf="item.isFavorite == false">
             </span>
            </a>
           
            <a class="pe-pointer text-primary" (click)="showCompanyInfo(item)">
              {{item.companyName}}
            </a>
           </td>
           <td>
                {{item.naicsCode}} - {{item.naicsTitle}}
        </td>
        <td>
              {{item.state}}
        </td>
      </tr>
    </ng-template>
  </p-table>

        <p-paginator [rows]="recordsPerPage" (onPageChange)="paginationEvent($event)" *ngIf="totalElementCount > 0"
            [totalRecords]="totalElementCount"  
              [rowsPerPageOptions]="pageSizeOptions" length="totalElementCount"></p-paginator>

</div>

<div *ngIf="totalElementCount == 0 && !employerDialogDisplay" class="container-fluid px-3 py-4 bg-white d-flex justify-content-center">
  No Records Found !!!
</div>
<div *ngIf="employerDialogDisplay" class="bg-white p-4 mt-4">
  <div style="display: flex;flex-direction: row-reverse;">
    <button pButton pRipple type="button" icon="pi pi-times" (click)="closeCompanyInfo();"
    class="p-button-rounded p-button-secondary p-button-text"></button>
  </div>
<p-tabView>
  <p-tabPanel header="Information">
    <p-table class="margin-4" 
    [value]="individualCompany">
    <ng-template pTemplate="header">
      <tr>
          <th class="col-4">Employer</th>
          <th class="col-4">NAICS Code</th>
          <th class="col-4">State</th>
      </tr>
  </ng-template>
    <ng-template pTemplate="body" let-item>  
      <tr>
        <td><a>{{item.companyName}}</a></td>
        <td>{{item.naicsCode}} - {{item.naicsTitle}}</td>
        <td>{{item.state}}</td>
      </tr>
    </ng-template>
  </p-table>
  </p-tabPanel>
  <p-tabPanel header="Visa">
    <p-tabView class="vertical-tabView">
      <p-tabPanel header="LCA">
        <div class="mx-2">
         <h5 class="text-primary">LCA Filing for H1B Visa Jobs</h5>

         <p-table *ngIf="lcaFilingsLength > 0"
         [value]="lcaFilingsResult">
         <ng-template pTemplate="header">
           <tr>
              <th class="col-1"></th>
               <th class="col-2">Certified</th>
               <th class="col-3">Certified Withdrawn</th>
               <th class="col-3">Denied</th>
               <th class="col-3">Withdrawn</th>
           </tr>
       </ng-template>
         <ng-template pTemplate="body" let-item> 
           <tr>
             <td>{{item.year}}</td>
             <td>{{item.certified}}</td>
             <td>{{item.certifiedExpired}}</td>
             <td>{{item.denied}}</td>
             <td>{{item.withdrawn}}</td>
           </tr>
         </ng-template>
        </p-table> 
        <div *ngIf="lcaFilingsLength == 0" class="d-flex justify-content-center  mt-4">
          No Records Found !!!
        </div>
        </div>
      </p-tabPanel>
      <p-tabPanel header="Green Card">
        <div class="mx-2">
          <h5 class="text-primary">LCA Filing for Green Card under PERM</h5>
          <p-table *ngIf="gcFilingsLength > 0"
          [value]="gcFilingsResult">
          <ng-template pTemplate="header">
            <tr>
               <th class="col-1"></th>
                <th class="col-2">Certified</th>
                <th class="col-3">Certified Withdrawn</th>
                <th class="col-3">Denied</th>
                <th class="col-3">Withdrawn</th>
            </tr>
        </ng-template>
          <ng-template pTemplate="body" let-item> 
            <tr>
              <td>{{item.year}}</td>
              <td>{{item.certified}}</td>
              <td>{{item.certifiedExpired}}</td>
              <td>{{item.denied}}</td>
              <td>{{item.withdrawn}}</td>
            </tr>
          </ng-template>
         </p-table> 
         <div *ngIf="gcFilingsLength == 0" class="d-flex justify-content-center  mt-4">
          No Records Found !!!
        </div>
         </div>
      </p-tabPanel>
      <p-tabPanel header="Petition">
        <div class="mx-2">
          <h5 class="text-primary">Petition Data</h5>
          <p-table *ngIf="petitonDataLength > 0"
          [value]="petitonDataResult">
          <ng-template pTemplate="header">
            <tr>
               <th class="col-1"></th>
                <th class="col-2">Initial Approval</th>
                <th class="col-3">Initial Denials</th>
                <th class="col-3">Continuing Approval</th>
                <th class="col-3">Continuing Denials</th>
            </tr>
        </ng-template>
          <ng-template pTemplate="body" let-item> 
            <tr>
              <td>{{item.ficialYear}}</td>
              <td>{{item.initialApprovals}}</td>
              <td>{{item.initialDenials}}</td>
              <td>{{item.continuingApprovals}}</td>
              <td>{{item.continuingDenials}}</td>
            </tr>
          </ng-template>
         </p-table> 
         <div *ngIf="petitonDataLength == 0" class="d-flex justify-content-center mt-4">
          No Records Found !!!
        </div>
         </div>
    </p-tabPanel>
    </p-tabView>
  </p-tabPanel>
</p-tabView>
</div>